/* shabima-polvos-offer.js
   Behaviour for the ONE/SIZE "Oferta por cantidad" landing.
   Scope: only runs inside .shabima-polvos-offer-page. No external calls.
   Handles the modo-de-uso video: the markup ships with preload="none" and the
   sources in data-src, so nothing is downloaded during initial page load. This
   script copies data-src -> src and calls load() only when the video is about
   to enter the viewport (IntersectionObserver, rootMargin 300px) or when the
   user hits the toggle, whichever happens first. Playback respects
   prefers-reduced-motion.
   The buy button is the official Releasit hook (buy_buttons block); this
   script never builds a form, cart, checkout, radios, selects or quantities. */
(function () {
  'use strict';

  var page = document.querySelector('.shabima-polvos-offer-page');
  if (!page) return;

  var motionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function prefersReducedMotion() {
    return !!(motionQuery && motionQuery.matches);
  }

  var video = page.querySelector('.spo-video');
  var btn = page.querySelector('[data-spo-video-toggle]');
  if (!video || !btn) return;

  var sourcesLoaded = false;

  function setState(playing) {
    btn.setAttribute('aria-pressed', String(playing));
    btn.setAttribute('aria-label', playing ? 'Pausar video' : 'Reproducir video');
  }

  /* Copy data-src -> src once and hand the media element its sources. */
  function loadSources() {
    if (sourcesLoaded) return;
    sourcesLoaded = true;

    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      var src = sources[i].getAttribute('data-src');
      if (src) {
        sources[i].setAttribute('src', src);
        sources[i].removeAttribute('data-src');
      }
    }

    try { video.load(); } catch (e) {}
  }

  function play() {
    loadSources();
    setState(true);
    var p;
    try { p = video.play(); } catch (e) { setState(false); return; }
    if (p && typeof p.catch === 'function') {
      p.catch(function () { setState(false); });
    }
  }

  function pause() {
    try { video.pause(); } catch (e) {}
    setState(false);
  }

  /* Near-viewport hydration: always fetch, autoplay only when motion is fine. */
  function hydrate() {
    loadSources();
    if (!prefersReducedMotion()) play();
  }

  setState(false);

  btn.addEventListener('click', function () {
    /* A click must work even if the observer has not fired yet. */
    if (video.paused) {
      play();
    } else {
      pause();
    }
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            observer.disconnect();
            hydrate();
            return;
          }
        }
      },
      { rootMargin: '300px 0px' }
    );
    observer.observe(video);
  } else {
    /* Fallback: defer to after the page has finished loading so the video
       never competes with the initial render. */
    if (document.readyState === 'complete') {
      hydrate();
    } else {
      window.addEventListener('load', hydrate, { once: true });
    }
  }

  if (motionQuery) {
    var onMotionChange = function (e) {
      if (e.matches && !video.paused) pause();
    };
    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', onMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(onMotionChange);
    }
  }
})();
